(function () {
    "use strict";

    angular.module("app.core").config([
        "$stateProvider",
        function ($stateProvider) {
            /*
             *
             *   make sure you write new-states under:
             *   address, province, county & neighbourhood
             *
             * */
            $stateProvider
                .state("analysis", {
                    abstract: true,
                    url: "/:langcode/{path:analiz|analysis|analisis|analise}",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },

                        path: ['$translate', function ($translate) {
                            return $translate.instant("analysis");
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/layout.html",
                    controller: "LayoutController",
                    controllerAs: "vm",
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Load base regional analysis bundle
                            return lazyLoadSvc.load($transition$, 'regionalAnalysis').then(function () {

                                return guardSvc.hasPackage([
                                    "eco-package",
                                    "seller-lead-package",
                                    "premium-package",
                                    "premiumplus-package",
                                    "pro-ee-package",
                                    "flex-package",
                                    "gold-package",
                                    "terminal-flex-package",
                                    "terminal-pro-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package",
                                    "location-package",
                                    "real-estate-package"
                                ]).then(function (HasProPackage) {
                                    if (HasProPackage) {
                                        return lazyLoadSvc.load($transition$, 'regionalAnalysisMember');
                                    }
                                }).then(function () {
                                    // Check for premium packages and load additional bundles
                                    return guardSvc.hasPackage([
                                        "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "location-package",
                                        "real-estate-package"
                                    ]).then(function (HasPremiumPlus) {
                                        if (HasPremiumPlus) {
                                            return lazyLoadSvc.load($transition$, 'regionalAnalysisPremium');
                                        }
                                    }).then(function () {
                                        return guardSvc.hasPackage([
                                            "platinum-package",
                                            "premium-ee-package",
                                            "terminal-premium-package",
                                            "terminal-package",
                                            "location-package",
                                            "real-estate-package"
                                        ]).then(function (HasPlatinumOrRealEstate) {
                                            if (HasPlatinumOrRealEstate) {
                                                return lazyLoadSvc.load($transition$, 'regionalAnalysisPlatinum');
                                            }
                                        });
                                    });
                                });
                            });
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect('analysis');
                        }],
                        TypeProtect: ['$transition$', '$translate', '$rootScope', '$timeout', function ($transition$, $translate, $rootScope, $timeout) {
                            const satilik = $transition$.params().satilik;
                            const konut = $transition$.params().konut;


                            var redirect = false;
                            if (satilik && satilik !== $translate.instant('kiralik') && satilik !== $translate.instant('satilik')) {
                                redirect = true;
                            }
                            if (konut && konut !== $translate.instant('konut')
                                && konut !== $translate.instant('ticari')
                                && konut !== $translate.instant('arazi')
                                && konut !== $translate.instant('arsa')) {
                                redirect = true;
                            }
                            if (redirect) {

                                // console.error(konut, $translate.instant('konut'), $translate.instant('ticari'), $translate.instant('arsa'), $translate.instant('arazi'));
                                // console.error(satilik, $translate.instant('satilik'), $translate.instant('kiralik'));
                                // $transition$.abort();
                                // $transition$.router.stateService.go("404", { langcode: $transition$.params().langcode });

                                var rental = satilik !== $translate.instant('kiralik') ? "satilik" : "kiralik";
                                var type;
                                if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("ticari") ||
                                    $transition$.params().konut === $translate.instant("plaza") ||
                                    $transition$.params().konut === $translate.instant("industrial") ||
                                    $transition$.params().konut === $translate.instant("ofis") ||
                                    $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                    $transition$.params().konut === $translate.instant("dukkan"))
                                    type = $translate.instant("ticari");
                                else if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("tarla") ||
                                    $transition$.params().konut === $translate.instant("arazi") ||
                                    $transition$.params().konut === $translate.instant("bahce"))
                                    type = $translate.instant("arazi");
                                else if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("arsa"))
                                    type = $translate.instant("arsa");
                                else
                                    type = $translate.instant("konut");

                                $timeout(function () {
                                    $rootScope.MetaTags.prerender.statusCode = 301;
                                    window.redirected = "Location: " + $transition$.router.stateService.href($transition$.to().name, { konut: $translate.instant(type), satilik: $translate.instant(rental), langcode: $transition$.params().langcode, country: $transition$.params().country, province: $transition$.params().province, county: $transition$.params().county, neighbourhood: $transition$.params().neighbourhood, address: $transition$.params().address, path: $transition$.params().path, path3: $transition$.params().path3 });
                                    $rootScope.MetaTags.prerender.header = window.redirected;
                                });
                                $transition$.abort();
                                $transition$.router.stateService.go($transition$.to().name, { konut: $translate.instant(type), satilik: $translate.instant(rental), langcode: $transition$.params().langcode, country: $transition$.params().country, province: $transition$.params().province, county: $transition$.params().county, neighbourhood: $transition$.params().neighbourhood, address: $transition$.params().address, path: $transition$.params().path, path3: $transition$.params().path3 });
                            }
                        }],

                        HasPackage: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage();
                        }],

                        HasDemo: ['guardSvc', 'HasPackage', function (guardSvc, HasPackage) {
                            return !HasPackage ? guardSvc.hasDemo('analysis') : false;
                        }],

                        HasRealEstate: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "real-estate-package",
                                "location-package",
                            ]);
                        }],

                        HasPlatinum: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "location-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package"
                            ]);
                        }],

                        HasPro: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "basic-package",
                                "eco-package",
                                "seller-lead-package",
                                "premium-package",
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasPremium: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "basic-package",
                                "eco-package",
                                "seller-lead-package",
                                "premium-package",
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasPremiumPlus: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasLocation: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage(["location-package"]);
                        }],

                        // MonthlyPackage: ['guardSvc', function (guardSvc) {
                        //     return guardSvc.monthlyPackage();
                        // }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_layout");
                            $translatePartialLoader.addPart("authentication");
                            $translatePartialLoader.addPart("endeks_modal");
                            // $translatePartialLoader.addPart("contract_agreement");
                            return $translate.refresh();
                        }]
                    },
                })
                .state("analysis.address", {
                    abstract: true,
                    url: "/l/:address",
                    params: {
                        address: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleAdres: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().address && $transition$.params().address.indexOf(";") === -1 &&
                                $transition$.params().address.indexOf("%252C") === -1
                            )
                                return (
                                    $transition$
                                        .params()
                                        .address.replaceAllString("-", ", ")
                                        .toLocaleProperCase2("tr-tr") + ", "
                                );
                            return "";//$translate.instant('title_nolocation');
                        }],
                    },
                })
                .state("analysis.address.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?pt?rad?top?ref?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        pt: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        l: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionValue: ['$translate', function ($translate) {
                            return $translate('c_an_keygen').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleAdres}}{{satilikTitle}} {{type}} {{fiyatlari}}, {{descriptionValue}} {{fiyatlari}}, {{descriptionValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.demographics", {
                    url: "/{path3:demografi|demography|demografia}?rad?top?ref?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleAddressDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressDemo}}",
                        description: "{{titleAdres}}{{descriptionAddressDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }]
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec3').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressElec}}",
                        description: "{{titleAdres}}{{descriptionAddressElec}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.address.competition", {
                    url: "/competition?oi?rad?d?ti?le",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],
                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.find", {
                    url: "/find?p?q?le",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        }
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_find1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.comparables", {
                    url: "/comparables?rad?top?ref?le?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",

                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }

                })
                .state("analysis.address.investment", {
                    url: "/investment?rad?top?ref?le?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",

                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        description: "{{titleAdres}}{{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }

                })

                .state("analysis.address.locations", {
                    url: "/locations?rad?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAdressEdu}}",
                        description: "{{titleAdres}}{{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {


                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} {{titleAddressTrans}}",
                        description: "{{titleAdres}}{{descriptionAddressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website"
                        },
                    },
                })
                .state("analysis.address.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressLife}}",
                        description: "{{titleAdres}}{{descriptionAddressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },

                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressHealth}}",
                        description: "{{titleAdres}}{{descriptionAddressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressEntertain}}",
                        description: "{{titleAdres}}{{descriptionAddressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.agents", {
                    url: "/agents?p?c?rad?top?ref?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleAddressOpporPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAddressOpporPrepend}}{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?rad?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],


                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.malls", {
                    url: "/malls?p?o?s?str?c?a?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}",
                    // params: {
                    //     country: {
                    //         value: null,
                    //     }
                    // },
                    resolve: {

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            function (searchParserService, $transition$) {
                                return searchParserService.parseSearchForController(
                                    $transition$.params(),
                                    $transition$
                                );
                            },
                        ],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                var title = resolveAPIs.Country;
                                title = title === "world" ? $translate.instant("World") : $translate.instant(title);
                                return title;
                            },
                        ],
                    },
                })
                .state("analysis.country.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        titleProvValueDescription2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{titleProvValueDescription2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.country.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvDemo}}",
                        description: "{{titleProvince}}{{descriptionProvDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'world' ? 'noindex, nofollow' : 'index', 'follow'; }]
                    },
                })
                .state("analysis.country.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }]
                    },
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            // if ($transition$.params().country !== 'turkiye') {
                            $transition$.abort();
                            $transition$.router.stateService.go("404", { langcode: window.lang });
                            // }
                        }],

                        titleProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvElec}}",
                        description: "{{titleProvince}}{{descriptionProvElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: 'noindex, nofollow'
                    }
                })

                .state("analysis.country.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        description: "{{titleProvince}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleProvOpportPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvOpportPrepend}}{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?name?ct?ppt?pt?lt?room?areamax?areamin?pricemax?pricemin?age?bosp?city?lake?nature?sea?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            function (searchParserService, $transition$) {
                                return searchParserService.parseSearchForController(
                                    $transition$.params(),
                                    $transition$
                                );
                            },
                        ],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],
                    },
                })
                .state("analysis.province.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        titleProvValueDescription2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{titleProvValueDescription2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.province.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvDemo}}",
                        description: "{{titleProvince}}{{descriptionProvDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvElec}}",
                        description: "{{titleProvince}}{{descriptionProvElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })

                .state("analysis.province.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],
                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        description: "{{titleProvince}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleProvOpportPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvOpportPrepend}}{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?name?ct?ppt?pt?lt?room?areamax?areamin?pricemax?pricemin?age?bosp?city?lake?nature?sea?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],
                    },
                })
                .state("analysis.county.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionCountyValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionCountyValue2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.county.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleCountyDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyDemo}}",
                        description: "{{titleProvince}} {{titleCounty}}{{descriptionCountyDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyElec}}",
                        description: "{{titleProvince}} {{titleCounty}}{{descriptionCountyElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })

                .state("analysis.county.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyReal}}",
                        robots: "noindex, nofollow",
                        keyword: "{{keywordCountyReal}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleCountyOppPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCountyOppPrepend}}{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.neighbourhood", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', function (resolveAPIs) {
                            var district = resolveAPIs.Quarter || resolveAPIs.District;
                            return district; //$transition$.params().neighbourhood.toLocaleProperCase2("tr-tr");
                        }],

                    },
                })
                .state("analysis.neighbourhood.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],





                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.neighbourhood.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Check for premium packages and load additional bundles
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisLocation');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        // robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        // robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood/:block",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        },
                        block: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', '$transition$', function (resolveAPIs, $transition$) {
                            if ($transition$.params().country === 'espana' && resolveAPIs.Quarter) {
                                return resolveAPIs.Quarter + ' ' + resolveAPIs.District;
                            }
                            var langKey = $transition$.params().langcode || 'tr';
                            var result;
                            if (langKey === 'tr')
                                result = resolveAPIs.BlockNo + ' Ada';
                            else
                                result = resolveAPIs.BlockNo + ' Block';
                            var district = resolveAPIs.District + ' ' + result;
                            return district;
                        }],

                    },
                })
                .state("analysis.block.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],




                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.block.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Check for premium packages and load additional bundles
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisLocation');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
                .state("analysis.block.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood/:block/:parcel",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        },
                        block: {
                            value: null
                        },
                        parcel: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', '$transition$', function (resolveAPIs, $transition$) {
                            var langKey = $transition$.params().langcode || 'tr';
                            var result;
                            if (langKey === 'tr')
                                result = resolveAPIs.BlockNo + ' Ada/' + resolveAPIs.ParcelNo + ' Parsel';
                            else
                                result = resolveAPIs.BlockNo + ' Block/' + resolveAPIs.ParcelNo + ' Plot';

                            var district = resolveAPIs.District + ' ' + result;
                            return district;
                        }],
                    }
                })
                .state("analysis.parcel.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi?rad",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi?rad",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.parcel.competition", {
                    url: "/competition?oi?rad",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.comparables", {
                    url: "/comparables?top?ref?rad?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.investment", {
                    url: "/investment?top?ref?rad?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{descriptionNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?rad?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                });


        }
    ]);
})();
